export const INPUT_FIELD_MIN_WIDTH = 60;
